import { ApiStatus } from "@Src/constants";

export const getFavoritesList = (state) => state.favoritesList.stores;
export const getFavoritedStores = (state) => state.favoritedStores.stores;
export const getApiStatus = (state) => state.favoritesList.api;
export const getFavoritedStoresApiStatus = (state) => state.favoritedStores.api;
export const getFavoritedStoresInitLoading = (state) => {
  return state.favoritedStores.api.status === ApiStatus.LOADING;
};
export const getFavoritesListInitLoading = (state) => {
  return state.favoritesList.api.status === ApiStatus.LOADING && !state.favoritesList.stores.length;
};
